// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pukcbqfjzswqmjkhwzfk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1a2NicWZqenN3cW1qa2h3emZrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyNjE5MDcsImV4cCI6MjA3NzgzNzkwN30.147Wgo0GkUPgBjqhSATjNtTSSfZDfZHhBmlOUnTiFdU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});